import React, {Component} from 'react';
import App from "../../App";
import  Pagination from 'react-js-pagination';
import {withRouter, Link} from "react-router-dom";
import "../../assets/scss/order-list.scss";
import {ToastsContainer, ToastsStore} from 'react-toasts';
import {getPaginatedList } from "../../services/baseServices";
import { FiEye } from "react-icons/all";
class List extends Component {
  constructor() {
    super();
    this.state = {
      riders: [],
      activePage: 1,
      per_page: 15,
      page: 1,
      counter: 1
    };
  }

  getRiderList = () => {
    getPaginatedList('riders',{per_page: this.state.per_page, page: this.state.page} )
    .then(res => {
        this.setState({ riders: res?.data?.data,
          per_page: res.headers['x-per-page'],
          total_data: res.headers['x-total'],
        })
    })
    .catch(errMsg => {
      console.log('Err Msg: ', errMsg)
    })
  }

  componentDidMount() {
    this.getRiderList()
  }

  handlePageChange = (pageNumber) => {
    this.setState({ page: pageNumber, activePage: pageNumber, isLoading: true}, () => {
      // this.getQueryData();
      this.getRiderList()
    });
  }

  render() {
    return (
      <App layout="">
        <div className="main-content">
          <div className="page-header">
            <h2 className="page-title">Rider List</h2>
            
          </div>

          <div className="card-block">
            <div className="block-body">

              <table className="order-table table table-striped">
                <thead>
                <tr>
                  <th style={{width: '20px'}}>#</th>
                  <th>Rider Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                  {this.state.riders?.length > 0 &&
                    this.state.riders?.map((rider, index) => {
                      return ( 
                        <tr key={index}>
                          <td>{((this.state.page - 1) * this.state.per_page) + index + 1}</td>
                          <td>
                            <div className="order-item text-break">
                                  {rider.name}
                            </div>
                          </td>
                          <td>
                            <div className="order-item text-break">
                                {rider.email}
                            </div>
                          </td>
                          <td>
                            <div className="order-item">
                                {rider.phone}
                            </div>
                          </td>
                          <td> <Link to={`/rider/details/${rider.id}`} className="btn btn-sm btn-default"><FiEye/></Link></td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
            <div className="mt-3">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={this.state.activePage}
                itemsCountPerPage={this.state.per_page}
                totalItemsCount={this.state.total_data}
                pageRangeDisplayed={10}
                onChange={this.handlePageChange.bind(this)}
              />
            </div>
          </div>
        </div>
        <ToastsContainer store={ToastsStore}/>
      </App>
    );
  }
}

export default withRouter(List);
